import classNames from 'classnames';
import PropTypes from 'prop-types';

const SearchListIconAlt = ({ className }) => {
  const iconClassName = classNames('search-list-icon-alt', className);

  return (
    <svg className={iconClassName} width='19' viewBox='0 0 19 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.9375 7.00617C5.9375 4.01117 8.36542 1.58325 11.3604 1.58325C14.3554 1.58325 16.7833 4.01117 16.7833 7.00617C16.7833 8.21811 16.3858 9.33719 15.714 10.2401L17.8125 12.3387L16.6929 13.4583L14.5944 11.3597C13.6914 12.0315 12.5724 12.4291 11.3604 12.4291C8.36542 12.4291 5.9375 10.0012 5.9375 7.00617ZM11.3604 3.16659C9.23987 3.16659 7.52083 4.88563 7.52083 7.00617C7.52083 9.12671 9.23987 10.8458 11.3604 10.8458C13.481 10.8458 15.2 9.12671 15.2 7.00617C15.2 4.88563 13.481 3.16659 11.3604 3.16659Z'
        fill='#9A9AAB'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.35417 5.54161L1.1875 5.54159L1.18752 3.95825L4.35418 3.95827L4.35417 5.54161Z'
        fill='#9A9AAB'
      />
      <path fillRule='evenodd' clipRule='evenodd' d='M4.35417 11.0833H1.1875V9.5H4.35417V11.0833Z' fill='#9A9AAB' />
      <path fillRule='evenodd' clipRule='evenodd' d='M16.2292 17.4166H1.1875V15.8333H16.2292V17.4166Z' fill='#9A9AAB' />
    </svg>
  );
};

SearchListIconAlt.propTypes = {
  className: PropTypes.string,
};

export default SearchListIconAlt;
